// extracted by mini-css-extract-plugin
module.exports = {"footer":"pages-sponsorships-modals-editPaper__footer--39JQs","button":"pages-sponsorships-modals-editPaper__button--35rD3"};